import DocumentationHub from '../components/shared/DocumentationHub';

/**
 * Help page wrapper that detects user role from URL path.
 * Routes: /consumer/help, /retailer/help, /admin/help, /charity/help
 */
export default function HelpPage() {
  // Detect role from URL path
  const path = window.location.pathname;
  let userRole = 'consumer';
  
  if (path.includes('/retailer')) {
    userRole = 'retailer';
  } else if (path.includes('/admin')) {
    userRole = 'admin';
  } else if (path.includes('/charity')) {
    userRole = 'charity';
  }

  return <DocumentationHub userRole={userRole} />;
}
